import { MenuItem, Select, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Label, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { getGenderActivity } from '../../features/dashboard/dashboardSlice';
import { getLabelsByInstituteType } from '../../utils/constants';
import { MenuProps } from '../../utils/constants';
const GenderActivity = ({ GenderDetails, classesData }) => {
  const dispatch = useDispatch();
  const [classDetails, setClassDetails] = useState([]);
  const [departmentName, setDepartmentName] = useState('');
  const [genderOverview, setGenderOverview] = useState({
    total: 0,
    Male: 0,
    Female: 0,
  });
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const { Department } = getLabelsByInstituteType(instituteType);
  async function fetchGenderActivity(dept) {
    const data = await dispatch(getGenderActivity(dept)).unwrap();
    data ? setGenderOverview(data) : '';
  }
  useEffect(() => {
    setGenderOverview(
      GenderDetails || {
        total: 0,
        Male: 0,
        Female: 0,
      },
    );
    setClassDetails(classesData);
  }, [GenderDetails, classesData]);
  return (
    <div className='bg-white rounded-lg shadow-md size-full'>
      <div className='flex justify-center gap-4 pt-2 px-3 '>
        <Typography variant='h6'>Gender Activity</Typography>
        <Select
          MenuProps={MenuProps}
          displayEmpty
          value={departmentName}
          onChange={(e) => {
            if (e.target.value) {
              fetchGenderActivity(e.target.value);
            }
            setDepartmentName(e.target.value);
          }}
          labelId='class-label'
          className='ml-auto'
          sx={{
            maxWidth: 'fit',
            height: '24px',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ccc', // normal border color
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ccc', // normal border color
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ccc', // keep same on hover
            },
            '&.MuiSelect-select:focus': {
              backgroundColor: 'transparent', // remove blue background on focus
            },
          }}
        >
          <MenuItem value='' onClick={() => fetchGenderActivity('')}>
            {Department}
          </MenuItem>

          {classDetails?.length > 0 &&
            classDetails?.map((obj) => (
              <MenuItem key={obj.id} value={obj.department}>
                {obj.department}
              </MenuItem>
            ))}
        </Select>
      </div>

      {genderOverview?.total > 0 ? (
        <div className='overflow-auto'>
          <div style={{ height: 230 }} className=' flex lg:mt-4  min-w-[280px]'>
            <ResponsiveContainer>
              <PieChart>
                {/* OUTER BACKGROUND */}
                <Pie
                  data={[{ value: 100 }]}
                  dataKey='value'
                  cx='50%'
                  cy='50%'
                  innerRadius={60}
                  outerRadius={75}
                  startAngle={90}
                  endAngle={-270}
                  fill='#eef2f7'
                  isAnimationActive={false}
                />

                {/* OUTER PROGRESS (MALE) */}
                <Pie
                  data={[{ value: genderOverview.Male }]}
                  dataKey='value'
                  cx='50%'
                  cy='50%'
                  innerRadius={60}
                  outerRadius={75}
                  startAngle={-90} // TOP
                  endAngle={
                    -90 -
                    ((genderOverview.Male / genderOverview.total) * 100 * 360) /
                      100
                  }
                  fill='#3b82f6'
                  cornerRadius={14}
                />

                {/* INNER BACKGROUND */}
                <Pie
                  data={[{ value: 100 }]}
                  dataKey='value'
                  cx='50%'
                  cy='50%'
                  innerRadius={40}
                  outerRadius={55}
                  startAngle={90}
                  endAngle={-270}
                  fill='#eef2f7'
                  isAnimationActive={false}
                >
                  <Label
                    content={
                      <text
                        x='50%'
                        y='50%'
                        textAnchor='middle'
                        dominantBaseline='middle'
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        <tspan x='50%' style={{ fontSize: '14px' }}>
                          Total
                        </tspan>
                        <tspan x='50%' dy='16'>
                          {genderOverview.total}
                        </tspan>
                      </text>
                    }
                  />
                </Pie>

                {/* INNER PROGRESS (FEMALE) */}
                <Pie
                  data={[{ value: genderOverview.Female }]}
                  dataKey='value'
                  cx='50%'
                  cy='50%'
                  innerRadius={40}
                  outerRadius={55}
                  startAngle={90} // BOTTOM (opposite of -90)
                  endAngle={
                    90 -
                    ((genderOverview.Female / genderOverview.total) *
                      100 *
                      360) /
                      100
                  }
                  fill='#fb923c'
                  cornerRadius={14}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className='flex flex-col justify-center w-40 '>
              <div className='flex  gap-2 '>
                {' '}
                <div className='w-5 h-3 mt-2 rounded-full bg-[#3b82f6]'></div>
                <div>
                  <div>Male</div>
                  <div className='text-gray-400'>{genderOverview.Male}</div>
                </div>
              </div>
              <div className='flex  gap-2 '>
                {' '}
                <div className='w-5 h-3 mt-2 rounded-full bg-[#fb923c]'></div>
                <div>
                  <div>Female</div>
                  <div className='text-gray-400'>{genderOverview.Female}</div>
                </div>
              </div>
              {genderOverview.total -
                genderOverview.Male -
                genderOverview.Female >
                0 && (
                <div className='flex  gap-2 '>
                  {' '}
                  <div className='w-5 h-3 mt-2 rounded-full bg-gray-600'></div>
                  <div>
                    <div>Others</div>
                    <div className='text-gray-400'>
                      {genderOverview.total -
                        genderOverview.Male -
                        genderOverview.Female}
                    </div>{' '}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className=' size-full flex justify-center items-center  h-[190px] '>
          No Gender Activity
        </div>
      )}
      {}
    </div>
  );
};
export default GenderActivity;
